import { useSession } from '@faststore/sdk'
import { useCallback, useEffect } from 'react'
import {
  resetOverrideToken,
  useHasMarketingConsent,
} from 'src/sdk/analytics/hooks/useUserToken'
import { BK_ID_STORAGE_KEY } from 'src/sdk/session/validate'
import {
  COOKIEBOT_ACCEPT,
  COOKIEBOT_DECLINE,
  COOKIEBOT_READY,
} from '../ThirdPartyScripts/DynamicYieldScriptLoader'

const deleteCookie = (name: string) => {
  const expired = 'expires=Thu, 01 Jan 1970 00:00:00 UTC'
  document.cookie = `${name}=; ${expired}; path=/`
  document.cookie = `${name}=; ${expired}; path=/; domain=${location.hostname}`
  document.cookie = `${name}=; ${expired}; path=/; domain=.${location.hostname}`
}

export const UserTokenConsentHandler = () => {
  const { person } = useSession()
  const hasConsent = useHasMarketingConsent()

  const setAuthenticatedUserTokenConsent = useCallback(
    (hasConsent: boolean) => {
      if (!hasConsent) {
        window?.aa?.('setAuthenticatedUserToken', undefined) // without consent, we remove the authenticated user token
        return
      }

      // Otherwise we set the authenticated user token aswell, if user is logged in
      const userData = JSON.parse(
        window.localStorage.getItem(BK_ID_STORAGE_KEY) || '{}'
      )
      const bkId = userData.bk_id
      if (bkId && window.aa) {
        window.aa(
          'getAuthenticatedUserToken',
          {},
          (err: Error, authenticatedUserToken: string) => {
            if (err) {
              console.error(err, 'error-usertoken')
              return
            }
            if (authenticatedUserToken === bkId) {
              return
            }
            window.aa('setAuthenticatedUserToken', bkId)
          }
        )
      }
    },
    []
  )

  // token autenticato: riparte quando cambia person o consenso
  useEffect(() => {
    if (!person) return
    setAuthenticatedUserTokenConsent(hasConsent)
  }, [person, hasConsent, setAuthenticatedUserTokenConsent])

  // revoca: l'init e il token anonimo li gestisce il componente
  useEffect(() => {
    const handleConsentChange = () => {
      if (window.Cookiebot?.consent?.marketing !== false) return

      deleteCookie('_ALGOLIA')
      window.aa?.('init', {
        partial: true,
        userHasOptedOut: true,
        useCookie: false,
      })
      resetOverrideToken()
    }

    window.addEventListener(COOKIEBOT_READY, handleConsentChange)
    window.addEventListener(COOKIEBOT_ACCEPT, handleConsentChange)
    window.addEventListener(COOKIEBOT_DECLINE, handleConsentChange)

    return () => {
      window.removeEventListener(COOKIEBOT_READY, handleConsentChange)
      window.removeEventListener(COOKIEBOT_ACCEPT, handleConsentChange)
      window.removeEventListener(COOKIEBOT_DECLINE, handleConsentChange)
    }
  }, [])

  return null
}
